import api from '@/helpers/api'

const API_READ=`/api/tier-duration/`
const API_CHECK=`${API_READ}check-duration/`
const API_UPDATE=API_READ
const API_CREATE=API_READ

export default {
  namespaced:true,
  state: {
    status: '',
    MemberTierDurationForm:[],
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    read(state, { MemberTierDurationFormDurationForm }) {
      state.MemberTierDurationForm = [...MemberTierDurationFormDurationForm]
    },
    checkDuration(state, { MemberTierDurationFormDurationForm }) {
      state.MemberTierDurationForm = [...MemberTierDurationFormDurationForm]
    },
    error(state) {
      state.status = 'error'
    },
    success(state) {
      state.status = 'success'
    },
    add_filter(state, { filter }) {
      state.filter = filter;
    },
  },
  actions: {
    checkDuration({commit},id){
      
      // console.log(id, 'idasdasdasd');
      //       debugger;
        commit('request');

        return new Promise((resolve, reject) => {
            api.request('get', `${API_CHECK}${id}`)
            .then((result) => {
              // console.log(result.data);
              // debugger;
                commit('success')
                // commit('read',{MemberTierDurationForm:result.data.data})
                return resolve(result.data.data)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err);
            });
        });
    },
    read({commit},id){
      
      // console.log(id, 'idasdasdasd');
      //       debugger;
        commit('request');

        return new Promise((resolve, reject) => {
            api.request('get', `${API_READ}${id}`)
            .then((result) => {
              // console.log(result.data);
              // debugger;
                commit('success')
                // commit('read',{MemberTierDurationForm:result.data.data})
                return resolve(result.data.data)
            }).catch((err) => {
                commit('error', {message: err})
                return reject();
            });
        });
    },
    update({commit},{data}){
    
      // console.log('update', commit, data);
      // debugger;
        commit('request');

        return new Promise((resolve, reject) => {
            api.request('put', `${API_UPDATE}${data.corporate_id}`, {}, data)
            .then((request) => {
                commit('success');
                return resolve(request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    create({commit},{data}){
    
      // console.log('create', commit, data);
      // debugger;
      commit('request');

      return new Promise((resolve, reject) => {
          api.request('post', API_CREATE, {}, data)
          .then((response) => {
              commit('success');
              return resolve(response)
          }).catch((err) => {
              commit('error', {message: err})
              return reject(err)    
          });
      });
    }
  },
  getters : {
    MemberTierDurationForm: ()=>state => state.MemberTierDurationForm,
  }
}